<template>
	<div class="machine-advert-group">
		<search-machine-advert-group-label
			v-on:addMachineAdvertGroup="addMachineAdvertGroup"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-machine-advert-group-label>
		<add-machine-advert-group-label
			v-on:cancel="cancel"
			:advertGroupList="advertGroupList"
			:userMachineGroupList="userMachineGroupList"
			:dialogMachineAdvertGroup="dialogMachineAdvertGroup"
			:machineAdvertGroup="machineAdvertGroup"
		>
		</add-machine-advert-group-label>
		<advert-group
			:showType="showType"
			:advertGroupId="advertGroupId"
			v-on:cancelAdvertGroup="cancelAdvertGroup"
			:dialogAdvertGroup="dialogAdvertGroup"
		></advert-group>
		<user-machine-group-label
			:userEquipmentLabelTeamId="userEquipmentLabelTeamId"
			v-on:cancelUserMachineGroup="cancelUserMachineGroup"
			:dialogUserMachineGroup="dialogUserMachineGroup"
		></user-machine-group-label>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="machineAdvertGroupList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userName"
					:show-overflow-tooltip="true"
					:label="$t('machineAdvertGroup.userName')"
					width="250"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="adTeamName"
					:label="$t('machineAdvertGroup.advertGroupName')"
					width="250"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('machineAdvertGroup.advertGroupList')"
							placement="top"
						>
							<el-button type="text" @click="advertGroup(scope.row.adTeamId)">{{
								scope.row.adTeamName
							}}</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="userEquipmentLabelTeamName"
					label="Machine Label"
					width="250"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-tooltip
							class="item"
							effect="dark"
							content="Click to view tab group list"
							placement="top"
						>
							<el-button
								type="text"
								@click="userMachineGroup(scope.row.userEquipmentLabelTeamId)"
								>{{ scope.row.userEquipmentLabelTeamName }}</el-button
							>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="notes"
					:label="$t('machineAdvertGroup.notes')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('machineAdvertGroup.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 155 : 155"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['machine:advert:update']"
							@click="editMachineAdvertGroup(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							size="mini"
							type="danger"
							v-hasPerm="['machine:advert:delete']"
							@click="deleteMachineAdvertGroup(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import addMachineAdvertGroupLabel from "_c/adverts/AddMachineAdvertGroupLabel";
import searchMachineAdvertGroupLabel from "_c/adverts/SearchMachineAdvertGroupLabel";
import AdvertGroup from "_c/adverts/AdvertGroup";
import userMachineGroupLabel from "_c/adverts/UserMachineGroupLabel";
export default {
	name: "MachineAdvertLabel",
	components: {
		addMachineAdvertGroupLabel,
		searchMachineAdvertGroupLabel,
		AdvertGroup,
		userMachineGroupLabel,
	},
	data() {
		return {
			search: {
				userName: "",
				adTeamName: "",
				userEquipmentLabelTeamName: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			dialogMachineAdvertGroup: false,
			loading: false,
			machineAdvertGroupList: [],
			machineAdvertGroup: {
				id: "",
				advertGroupId: "",
				teamId: "",
				notes: "",
			},
			advertGroupList: [],
			userMachineGroupList: [],
			advertGroupId: "",
			userEquipmentLabelTeamId: "",
			dialogUserMachineGroup: false,
			dialogAdvertGroup: false,
			showType: [],
		};
	},
	mounted() {
		this.currentChange();
		this.listUserMachineGroup();
		this.listAdvertGroup();
		this.listShowType();
	},
	methods: {
		listShowType() {
			this.$api.dict("gp_show_type").then(res => {
				if (res.code === 0) {
					this.showType = res.data;
				}
			});
		},
		listUserMachineGroup() {
			this.$api
				.request(this.$url.UserMachineLabels.list, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.userMachineGroupList = res.data;
					}
				});
		},
		listAdvertGroup() {
			this.$api
				.request(this.$url.AdvertGroup.list, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.advertGroupList = res.data;
					}
				});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.MachineAdvertGroupLabel.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.machineAdvertGroupList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		cancel(dialog, state) {
			this.dialogMachineAdvertGroup = dialog;
			if (state) {
				this.currentChange(this.page.pageIndex);
			}
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		addMachineAdvertGroup() {
			this.dialogMachineAdvertGroup = true;
		},
		editMachineAdvertGroup(row) {
			this.dialogMachineAdvertGroup = true;
			Object.keys(this.machineAdvertGroup).forEach(key => {
				this.machineAdvertGroup[key] = row[key];
			});
			this.machineAdvertGroup.id = row.id;
		},
		deleteMachineAdvertGroup(row) {
			this.$confirm(
				this.$t("machineAdvertGroup.delete"),
				this.$t("common.warning"),
				{
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}
			).then(() => {
				this.$api
					.request(
						this.$url.MachineAdvertGroupLabel.delete,
						this.$method.delete,
						{
							id: row.id,
						}
					)
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange(this.page.pageIndex);
						}
					});
			});
		},
		advertGroup(data) {
			this.advertGroupId = data;
			this.dialogAdvertGroup = true;
		},
		userMachineGroup(data) {
			this.userEquipmentLabelTeamId = data;
			this.dialogUserMachineGroup = true;
		},
		cancelAdvertGroup(dialog) {
			this.dialogAdvertGroup = dialog;
		},
		cancelUserMachineGroup(dialog) {
			this.dialogUserMachineGroup = dialog;
		},
	},
};
</script>

<style lang="scss">
.machine-advert-group {
	.el-button--text {
		padding: 0 !important;
	}
}
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
